import React, { useEffect } from 'react';

import { Platform } from 'react-native';

import { useNavigation } from 'hooks/navigation/use-navigation';
import useEffectOnce from 'hooks/use-effect-once';
import useBranch from 'state/branch/hooks/use-branch';
import { checkForOSPrompts } from 'state/location/routes';
import { brand, isLocalDev } from 'utils/environment';
import { DeeplinkEventArgs, EventName, addEventListener } from 'utils/event-hub';

/**
 for miscellaneous platform specific components/hooks ONLY - if not platform specific put in ./generic-miscellaneous.tsx
 */
export const PlatformSpecificMiscellaneous: React.FC = React.memo(() => {
  const { navigate } = useNavigation();
  const { initBranch } = useBranch();

  useEffect(() => {
    if (!isLocalDev) {
      const renderSuccessTime = performance.now?.();
      const durationTillRenderSuccess = renderSuccessTime - LOADING_START_TIME;
      (window.dataLayer || []).push({
        event: 'APP_REACT_RENDER_SUCCESS',
        brand: brand(),
        timestamp: renderSuccessTime,
        duration: durationTillRenderSuccess,
        platform: Platform.OS,
      });
    }
  }, []);

  // Initialize Deeplink listeners
  useEffectOnce(() => {
    addEventListener<DeeplinkEventArgs>(EventName.DEEPLINK, deeplinkArgs => {
      // Ensure removing deeplink extra slash for RN
      const sanitizeRegex = /[/]+/;
      const deepLinkPath = deeplinkArgs.route.replace(sanitizeRegex, '/');

      if (!checkForOSPrompts(deepLinkPath)) {
        navigate(deepLinkPath);
      }
    });

    // Ensure deep link listener singleton is instantiated
    // TODO: RN-WEB - Implement Branch deeplinks
    //DeeplinksListener.getInstance();

    if (window && !window.branch) {
      initBranch();
    }
  });

  return null;
});

// Create start time before trying to render the app for true performance numbers
const LOADING_START_TIME = performance.now?.() ?? 0;
